import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CryptoService } from 'src/app/services/crypto/crypto.service';
import { CmdbExportPageService } from 'src/app/page/report/cmdb-export-page/service/cmdb-export-page.service';
import { ExcelService } from 'src/app/services/excel/excel.service';
import { NotificationService } from 'src/app/services/notification/notification.service';
import { genericFormInterface } from 'src/app/util/interfaces/genericForm';

@Component({
	selector: 'app-cmdb-report-download',
	templateUrl: './cmdb-report-download.component.html',
	styleUrls: ['./cmdb-report-download.component.scss'],
})
export class CmdbReportDownloadComponent implements OnInit {
	userParams = '';

	constructor(
		private ActivatedRoute: ActivatedRoute,
		private CryptoService: CryptoService,
		private CmdbExportPageService: CmdbExportPageService,
		private ExcelService: ExcelService,
		private NotificationService: NotificationService
	) {}

	ngOnInit() {
		this.ActivatedRoute.queryParams.subscribe((parameters) => {
			if (parameters.t && parameters.l && parameters.c) {
				const userCustomerId = this.CryptoService.decryptB64(parameters.c);
				const userType = this.CryptoService.decryptB64(parameters.t);
				const userLanguage = this.CryptoService.decryptB64(parameters.l);
				this.userParams = '&customer_id=' + userCustomerId + '&user_type=' + userType + '&user_language=' + userLanguage;
			}
			if (parameters.p) {
				const reportParameters = <genericFormInterface[]>JSON.parse(this.CryptoService.decryptB64(parameters.p));
				this.exportSavedReport(reportParameters);
			}
		});
	}

	convertToQueryString(reportParameters: genericFormInterface[]): string {
		let qryString = '';

		for (const parameter of reportParameters) {
			qryString += `&${parameter.name}=`;
			const values = parameter.values.filter((value) => value.toString().trim() !== '');
			qryString += parameter.name == 'type' ? values.join('') : values.join('§');
		}

		return qryString;
	}

	exportSavedReport(reportParameters: genericFormInterface[]) {
		const qryString = this.convertToQueryString(reportParameters);

		this.CmdbExportPageService.getExportableCMDBList(qryString + this.userParams).subscribe((spreadsheet) => {
			if (
				!spreadsheet.lines ||
				spreadsheet.lines.length === 0 ||
				!spreadsheet.lines[0].cells ||
				spreadsheet.lines[0].cells.length === 0
			) {
				this.NotificationService.setNotificationMessage('_Não encontramos nenhum resultado com este filtro!');
				return;
			}
			this.ExcelService.exportExcel(spreadsheet, 'report');
		});
	}
}
